import type { CosignatureQueueItem } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";

import { DocumentTypeMap } from "../constants";

export function adaptQueueData(items: CosignatureQueueItem[]) {
  return items.map((item) => ({
    dateSigned: item.signature_date ? dayjs(item.signature_date).format("MM/DD/YYYY") : null,
    daysPending: item.signature_date ? dayjs().diff(dayjs(item.signature_date), "day") : null,
    documentType: item.document_type,
    id: item.document_id,
    patientId: item.patient_id,
    patientName: item.patient_name,
    relatedNoteId: item.related_note_id ?? null,
    // raw ISO string used for correct date sort (dateSigned is MM/DD/YYYY, not lexicographically sortable)
    signatureDate: item.signature_date ?? null,
    status: item.cosignature_status,
    submittedBy: item.provider_name,
    type: DocumentTypeMap[item.document_type],
  }));
}

export type AdaptedQueueRow = ReturnType<typeof adaptQueueData>[number];
